<template>
  <div class="app">
    <div class="content" :class="{ printReady: this.$route.name === 'report' }">
      <Panel :authenticated="$store.getters.isAuthenticated"/>

      <div class="container">
        <LoadingModal v-if="loading"/>
        <FailedModal v-else-if="noAPI"/>
        <router-view v-else :authenticated="$store.getters.isAuthenticated"/>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchIsAuthenticated } from './http';
import Panel from './components/Panel';
import LoadingModal from './components/LoadingModal';
import FailedModal from './components/FailedModal';

export default {
  components: {
    Panel,
    LoadingModal,
    FailedModal
  },

  data() {
    return {
      loading: true,
      error: false,
      noAPI: false
    };
  },

  async created() {
    try {
      const isAuthenticated = await fetchIsAuthenticated();
      this.$store.commit('setAuthenticated', true);
    } catch (error) {
      if (!error.response || error.response.status === 404) {
        this.noAPI = true;
      } else {
        this.$router.push('/login');
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="sass">
@import './styles/bulma.sass'
@import './styles/main.sass'
</style>
